import * as actions from '../../actions/actions'

const initialState = {
    contiCorrenti: [],
    error: null
}

export default function contoCorrente(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_CONTO_CORRENTE_SUCCESS:
            return fetchContoCorrenteSuccess(state, action)
        case actions.FETCH_CONTO_CORRENTE_FAILURE:
            return fetchContoCorrenteFailure(state, action)
        case actions.DISABLE_CONTO_CORRENTE_SUCCESS:
            return disableContoCorrenteSuccess(state, action)
        case actions.DISABLE_CONTO_CORRENTE_FAILURE:
            return disableContoCorrenteFailure(state, action)
        case actions.ENABLE_CONTO_CORRENTE_SUCCESS:
            return enableContoCorrenteSuccess(state, action)
        case actions.ENABLE_CONTO_CORRENTE_FAILURE:
            return enableContoCorrenteFailure(state, action)
        case actions.DELETE_CONTO_CORRENTE_SUCCESS:
            return deleteContoCorrenteSuccess(state, action)
        case actions.DELETE_CONTO_CORRENTE_FAILURE:
            return deleteContoCorrenteFailure(state, action)
        default:
            return state
    }
}

const enableContoCorrenteSuccess = (state, action) => {
    return {
        ...state,
        contiCorrenti: action.contiCorrenti
    }
}

const enableContoCorrenteFailure = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}

const disableContoCorrenteSuccess = (state, action) => {
    return {
        ...state,
        contiCorrenti: action.contiCorrenti
    }
}

const disableContoCorrenteFailure = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}

const fetchContoCorrenteSuccess = (state, action) => {
    return {
        ...state,
        contiCorrenti: action.contiCorrenti
    }
}

const fetchContoCorrenteFailure = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}

const deleteContoCorrenteSuccess = (state, action) => {
    return {
        ...state,
        contiCorrenti: action.contiCorrenti
    }
}

const deleteContoCorrenteFailure = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}